(function($){
	$(document).ready(function() {
	
		// console.log('cur-product-safes-shipping.js loaded!');

		var $methods = $('.shipping-methods');
		var $atc     = $('button.add-to-cart');

		if(!$methods.length || !$atc.length){
			return;
		}

		var $form = $atc.closest('form');
		if(!$form.length){
			$form = $('form[action*="/cart/add"]').first();
		}
		if(!$form.length){
			return;
		}

		var messageclass = 'atc-shipping-message';

		function showmessage(){
			if(!$atc.next('.' + messageclass).length){
				$('<div class="' + messageclass + '">Select a shipping method above to add to cart</div>').insertAfter($atc);
			}
		}

		function hidemessage(){
			$atc.next('.' + messageclass).remove();
		}

		function ensureinputs(){
			if(!$form.find('input[name="properties[_delivery_method]"]').length){
				$form.append('<input type="hidden" name="properties[_delivery_method]" value="">');
			}
			if(!$form.find('input[name="properties[_delivery_title]"]').length){
				$form.append('<input type="hidden" name="properties[_delivery_title]" value="">');
			}
			if(!$form.find('input[name="properties[_delivery_price_display]"]').length){
				$form.append('<input type="hidden" name="properties[_delivery_price_display]" value="">');
			}
		}

		function setprops(method, title, pricedisplay){
			ensureinputs();
			$form.find('input[name="properties[_delivery_method]"]').val(method || '');
			$form.find('input[name="properties[_delivery_title]"]').val(title || '');
			$form.find('input[name="properties[_delivery_price_display]"]').val(pricedisplay || '');
		}

		function setatc(disabled){
			$atc.prop('disabled', disabled);

			if(disabled){
				showmessage();
				setprops('', '', '');
			}else{
				hidemessage();
			}
		}

		// initial state
		setatc(true);

		$methods.on('click', '.method-container', function(){

			var $methodbox = $(this).closest('.shipping-method');
			var isselected = $methodbox.hasClass('selected');

			// normalize UI state
			$methods.removeClass('selected');
			$methods.find('.shipping-method').removeClass('selected');
			$methods.find('.method-container').attr('aria-checked', 'false');

			if(!isselected){
				$methods.addClass('selected');
				$methodbox.addClass('selected');
				$(this).attr('aria-checked', 'true');

				var methodkey = $methodbox.attr('data-method') || '';
				var title = $.trim($methodbox.find('p.method-title').text());
				var pricedisplay = $.trim($methodbox.find('span.price').text());

				setprops(methodkey, title, pricedisplay);
				setatc(false);

			}else{
				setatc(true);
			}

		});

		// backstop: block submit if someone triggers submit while disabled / no selection
		$form.on('submit', function(e){
			var methodkey = $form.find('input[name="properties[_delivery_method]"]').val();
			if(!methodkey){
				e.preventDefault();
				setatc(true);
			}
		});


	});
})(jQuery);